import { Box, Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setTabIndex } from "../../ReduxStore/UserSlice";

const NextStepCard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isIpad = useMediaQuery('(min-width:768px) and (max-width:1024px)');
  const userDetail = useSelector((state) => state.user.user);

  const isLender = userDetail && 
    (userDetail.UserType || userDetail.userType || '').toLowerCase() === 'lender';

  if (isLender) {
    return null;
  }

  const handleEligibilityCheck = () => {
    try {
    window.scrollTo(0, 0);
    dispatch(setTabIndex(7));
      navigate("/calculator");
    } catch (error) {
      navigate("/calculator");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", lg: "row" }, // Stack elements vertically on mobile
        alignItems: { xs: "flex-start", sm: "center", lg: "center" },
        justifyContent: "space-between",
        backgroundImage: "url(/nextstepBanner.webp)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "16px",
        paddingX: { xs: "20px", sm: "30px", md: "50px", lg: "50px" },
        paddingY: { xs: "25px", sm: "30px", md: "30px", lg: "0" },
        color: "#FFFFFF",
        minHeight: { xs: "auto", sm: "240px", md: "260px" },
        maxWidth: "90%",
        margin: { xs: "20px 10px", sm: "20px 30px", md: "20px 70px 30px 70px" },
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Left Content */}
      <Box
        sx={{
          maxWidth: { xs: "100%", sm: "100%", md: "90%", lg: "50%" },
          marginBottom: { xs: "20px", sm: "15px", md: "20px", lg: "0" },
          paddingRight: { lg: "15px", xl: "20px" },
          paddingTop: { xs: "10px", lg: "0" },
          textAlign: { xs: "left", sm: "center", lg: "left" },
        }}
      >
        <Typography 
          variant="h7" 
          fontWeight="bold" 
          sx={{ 
            fontSize: { xs: "1.2rem", sm: "1.5rem", md: "1.6rem", lg: "1.5rem" },
            lineHeight: { xs: "1.3", sm: "1.4", md: "1.5" },
            display: "block",
          }}
        >
          Take the Next Step Towards Smarter Business Funding!
        </Typography>
        <Typography
          variant="body2"
          fontStyle="italic"
          sx={{ 
            marginTop: { xs: 1.5, sm: 2 }, 
            fontSize: { xs: "12px", sm: "15px", md: "16px" },
            lineHeight: { xs: "1.4", sm: "1.5", md: "1.6" },
            display: "block",
          }}
        >
          Unlock exclusive funding opportunities tailored for your business. Get
          instant credit analysis and connect with the right lenders — quick,
          secure, and hassle-free.
        </Typography>
        <Button
          variant="contained"
          sx={{
            marginTop: { xs: 2, sm: 3 },
            backgroundColor: "#18CB96",
            color: "#FFFFFF",
            padding: "8px 24px",
            textTransform: "none",
            fontSize: { xs: "0.7rem", sm: "0.75rem", md: "0.8rem", lg:"0.8rem" },
            fontWeight: "medium",
            "&:hover": { backgroundColor: "#14B384" },
          }}
          onClick={handleEligibilityCheck}
        >
          Check Eligibility
        </Button>
      </Box>

      {/* Right Image */}
      <Box 
        sx={{ 
          maxWidth: { xs: "100%", sm: "70%", md: "60%", lg: "40%" },
          width: { xs: "100%", sm: "100%", lg: "auto" },
          display: "flex",
          justifyContent: { xs: "center", sm: "center", lg: "flex-end" },
          alignItems: "center",
          marginTop: { xs: "5px", sm: "10px", lg: "0" },
          marginX: { xs: "0", sm: "auto", lg: "0" },
          paddingBottom: { xs: "5px", sm: "10px", lg: "0" },
          alignSelf: { xs: "center", sm: "center", lg: "auto" },
        }}
      >
        <img
          src="/nextstep.png"
          alt="Next Step"
          style={{
            width: isMobile ? "100%" : isTablet || isIpad ? "auto" : "100%",
            maxWidth: isMobile ? "220px" : isTablet || isIpad ? "300px" : "100%",
            height: "auto",
            maxHeight: isMobile ? "130px" : isIpad ? "200px" : isTablet ? "160px" : "180px",
            borderRadius: "8px",
            objectFit: "contain",
            marginTop: isMobile ? "10px" : "0",
          }}
        />
      </Box>
    </Box>
  );
};

export default NextStepCard;
